import Vue from "vue";

export const ActivitiesConfigurationPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/configurations/Layout.vue"
  );
export const ActivitiesConfigurationAreasPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/configurations/ActivityAreas.vue"
  );
export const ActivitiesConfigurationTypesPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/configurations/ActivityTypes.vue"
  );
export const ActivitiesConfigurationStatusPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/configurations/ActivityStatus.vue"
  );
export const ActivitiesConfigurationPrioritiesPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/configurations/ActivityPriorities.vue"
  );
export const ActivitiesDashboardPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/Dashboard.vue"
  );
export const ActivitiesListPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/List.vue"
  );
export const ActivitiesCalendarPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/Calendar.vue"
  );
export const ActivityDetailSharedPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Shared.vue"
  );
export const ActivityDetailDashboardPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Dashboard.vue"
  );
export const ActivityDetailUsersPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Users.vue"
  );
  export const ActivitiesDetailsLogTimes = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/LogTimes.vue"
  );
export const ActivityDetailCommentsPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Comments.vue"
  );
export const ActivityDetailDocumentsPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Documents.vue"
  );
export const ActivityDetailEditPage = () =>
  import(
    /* webpackChunkName: "activities-module" */ "@/views/activities/details/Edit.vue"
  );

export function registerActivitiesModule(r: any): any {
  /* Side Menus Components */
  Vue.component("CreateActivitySideMenuComponent", () =>
    import(
      /* webpackChunkName: "activities-module" */ "@/views/activities/side-menus/CreateActivity.vue"
    )
  );
  Vue.component("DetailActivitySideMenuComponent", () =>
    import(
      /* webpackChunkName: "activities-module" */ "@/views/activities/side-menus/DetailActivity.vue"
    )
  );

  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "/activities/configurations",
        component: ActivitiesConfigurationPage,
        children: [
          {
            path: "",
            redirect: "areas"
          },
          {
            path: "types",
            component: ActivitiesConfigurationTypesPage
          },
          {
            path: "status",
            component: ActivitiesConfigurationStatusPage
          },
          {
            path: "areas",
            component: ActivitiesConfigurationAreasPage
          },
          {
            path: "priorities",
            component: ActivitiesConfigurationPrioritiesPage
          }
        ]
      },
      {
        path: "activities/dashboard",
        component: ActivitiesDashboardPage
      },
      {
        path: "activities/calendar",
        component: ActivitiesCalendarPage
      },
      {
        path: "activities/list/:id",
        component: ActivitiesListPage
      },
      {
        path: "activity/:id",
        component: ActivityDetailSharedPage,
        children: [
          {
            path: "",
            redirect: "dashboard"
          },
          {
            path: "edit",
            component: ActivityDetailEditPage
          },
          {
            path: "dashboard",
            component: ActivityDetailDashboardPage
          },
          {
            path: "users",
            component: ActivityDetailUsersPage
          },
          {
            path: "log-times",
            component: ActivitiesDetailsLogTimes
          },
          {
            path: "documents",
            component: ActivityDetailDocumentsPage
          },
          {
            path: "comments",
            component: ActivityDetailCommentsPage
          }
        ]
      }
    );
  }
  return r;
}
